import { useContext, useState } from "react";
import { AlertContext } from "../context/AlertContext";
import { domain } from "../consts";
import { validatePassword } from "../utils/validate";
import { SVGS } from ".";
import { ResetPasswordStrings } from "../consts/strings";

const ResetPassword = ({ token, setDisplayComponent, formDisplay }) => {
  const { handleAlert } = useContext(AlertContext);
  const [isLoading, setLoading] = useState(false);
  const [form, setForm] = useState({
    password: "",
    confirmPassword: "",
  });

  const [formErr, setFormErr] = useState({
    password: false,
    confirmPassword: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "password") {
      setFormErr((prev) => ({
        ...prev,
        password: !validatePassword(value),
      }));
    }

    if (name === "confirmPassword") {
      setFormErr((prev) => ({
        ...prev,
        confirmPassword: form.password !== value,
      }));
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    if (formErr.password || !form.password.length) {
      handleAlert(ResetPasswordStrings.passwordAlert, "warning");
      setLoading(false);
      return;
    } else if (formErr.confirmPassword || !form.confirmPassword.length) {
      handleAlert(ResetPasswordStrings.confirmPasswordAlert, "warning");
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`${domain}/reset-password?token=${token}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ password: form.password }),
      });

      if (!response.ok) {
        const errorMessage = await response.text();
        handleAlert(ResetPasswordStrings.serverAlert, "error");
        throw new Error(errorMessage);
      }

      setLoading(false);
      handleAlert(ResetPasswordStrings.successAlert, "info", function () {
        setDisplayComponent(formDisplay.login);
      });
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <main className="w-full max-w-md mx-auto p-6">
      <div className="mt-7 bg-white border border-gray-200 rounded-xl shadow-sm    ">
        <div className="p-4 sm:p-7">
          <div className="text-center">
            <h1 className="block text-2xl font-bold text-gray-800  ">
              {ResetPasswordStrings.header}
            </h1>
            <p className="mt-2 text-sm text-gray-600  ">
              {ResetPasswordStrings.paragraph}
            </p>
          </div>

          <div className="mt-5">
            <form onSubmit={handleFormSubmit}>
              <div className="grid gap-y-4">
                <div>
                  <label
                    htmlFor="password"
                    className="block text-sm mb-2  "
                  >
                    {ResetPasswordStrings.password}
                  </label>
                  <div className="relative">
                    <input
                      type="password"
                      id="password"
                      name="password"
                      onChange={handleChange}
                      value={form.password}
                      className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                      aria-describedby="password-error"
                      disabled={isLoading}
                    />
                    <div
                      className={`${
                        !formErr.password && "hidden"
                      } mt-1 absolute inset-y-2 end-0 pointer-events-none pe-3`}
                    >
                      <SVGS.ErrorSVG />
                    </div>
                    <p
                      className={`${
                        !formErr.password && "hidden"
                      } text-xs text-red-600 mt-2`}
                      id="password-error"
                    >
                      {ResetPasswordStrings.passwordErr}
                    </p>
                  </div>
                </div>
                <div>
                  <label
                    htmlFor="confirmPassword"
                    className="block text-sm mb-2  "
                  >
                    {ResetPasswordStrings.confirmPassword}
                  </label>
                  <div className="relative">
                    <input
                      type="password"
                      id="confirmPassword"
                      name="confirmPassword"
                      onChange={handleChange}
                      value={form.confirmPassword}
                      className="py-3 px-4 block w-full border-gray-200 rounded-lg text-sm focus:border-teal-500 focus:ring-teal-500 disabled:opacity-50 disabled:pointer-events-none        :ring-gray-600"
                      aria-describedby="confirm-password-error"
                      disabled={isLoading}
                    />
                    <div
                      className={`${
                        !formErr.confirmPassword && "hidden"
                      } mt-1 absolute inset-y-2 end-0 pointer-events-none pe-3`}
                    >
                      <SVGS.ErrorSVG />
                    </div>
                    <p
                      className={`${
                        !formErr.confirmPassword && "hidden"
                      } text-xs text-red-600 mt-2`}
                      id="password-error"
                    >
                      {ResetPasswordStrings.confirmPasswordErr}
                    </p>
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full py-3 px-4 inline-flex justify-center items-center gap-x-2 text-sm font-semibold rounded-lg border border-transparent bg-teal-600 text-white hover:bg-teal-700 disabled:opacity-50 disabled:pointer-events-none  :outline-none  :ring-1  :ring-gray-600"
                  disabled={isLoading}
                >
                  {isLoading
                    ? ResetPasswordStrings.resetPasswordButtonLoading
                    : ResetPasswordStrings.resetPasswordButton}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </main>
  );
};

export default ResetPassword;
